import { Pipe, PipeTransform } from '@angular/core';

/**
 * 專用於 laas-car-type-selector 的顯示 Pipe。
 * 解析 "carType:count,..." 格式（如 "20GP:1,40HQ:2"），
 * 對應 options 標籤並附上數量，以 ", " 連接輸出。
 * 範例輸出：「20GP - 20呎普通 (CBM: 10) x 1, 40HQ - 40呎高箱 (CBM: 14) x 2」
 */
@Pipe({
  name: 'carTypeMapping'
})
export class CarTypeMappingPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const options: { label: string, value: any }[] = args[0];
    if (!value || typeof value !== 'string') return value;

    const labels = value.split(',')
      .map(segment => {
        const parts = segment.split(':');
        const code = parts[0].trim();
        const count = parts[1]?.trim();
        const label = options.find(x => String(x.value) === code)?.label ?? code;
        return count ? `${label} x ${count}` : label;
      })
      .filter(Boolean);

    return labels.length > 0 ? labels.join(', ') : value;
  }
}
